import { Component } from '@angular/core';
import { AgenxInputComponent } from "../../atoms/input/input.component";
import { Subscription } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AgenxAlertRadioComponent } from "../../moleculs/alert-radio/alert-radio.component";
import { AgenxSelectComponent } from "../../atoms/select/select.component";
import { REGEX } from '../../../../utils/constants';
import { DashboardService } from '../../../../services/dashboard.service';
import { ToastService } from '../../../../services/toast.service';
import { AgenxButtonComponent } from "../../atoms/button/button.component";
import { CardContent } from '../../../../interfaces/gauging.interface';
import { Client } from '../../../../interfaces/person.interface';
import { OfflineService } from '../../../../services/offline.service';
import { Router } from '@angular/router';
import { ClientService } from '../../../../services/clients.service';

@Component({
  selector: 'app-new-client-form',
  standalone: true,
  imports: [
    AgenxInputComponent,
    AgenxAlertRadioComponent,
    AgenxSelectComponent,
    AgenxButtonComponent,
  ],
  templateUrl: './new-client-form.component.html',
  styleUrl: './new-client-form.component.scss',
})
export class NewClientFormComponent {
  private subscriptions: Subscription[] = [];
  formClient = new FormGroup({
    name: new FormControl('', [Validators.required]),
    identification: new FormControl('', [Validators.required]),
    identification_type: new FormControl('', [Validators.required]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(REGEX.PHONE),
    ]),
    address: new FormControl('', [Validators.required]),
    neighborhood: new FormControl('', [Validators.required]),
    code: new FormControl(''),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(REGEX.EMAIL),
    ]),
  });
  typeIdentOpts = [
    { value: 'CC', label: 'CC' },
    { value: 'CE', label: 'CE' },
    { value: 'NIT', label: 'NIT' },
  ];
  no_internet = false;
  card_info: CardContent = { client: undefined, metadata: { registers: [] } };
  loading: 'loading' | 'normal' = 'normal';

  constructor(
    private clientSrv: ClientService,
    private offlineSrv: OfflineService,
    private router: Router,
    private toastSrv: ToastService
  ) {}

  get form() {
    return this.formClient.controls;
  }

  onTypeIdentChange(): void {
    if (this.form.identification_type.value === 'NIT') {
      this.form.identification.clearValidators();
      this.form.identification.addValidators([
        Validators.required,
        Validators.pattern(REGEX.NIT),
      ]);
    } else {
      this.form.identification.clearValidators();
      this.form.identification.addValidators([
        Validators.required,
        Validators.pattern(REGEX.NUMERIC),
      ]);
    }
    this.form.identification.markAsUntouched();
    this.form.identification.updateValueAndValidity();
    this.form.identification.markAsTouched();
  }

  save(): void {
    if (this.formClient.valid) {
      this.loading = 'loading';
      this.subscriptions.push(
        this.clientSrv.createClient(this.formClient.value).subscribe({
          next: (client: Client) => {
            client.is_new = true;
            this.card_info.client = client;
            this.card_info.metadata!.registers = [];
            this.offlineSrv.saveToLocal('special_data', this.card_info);
            this.router.navigateByUrl('/create_special');
          },
          error: (error: { error: { detailed: string } }) => {
            this.loading = 'normal';
            let message = error.error.hasOwnProperty('detailed')
              ? error.error.detailed
              : 'No se pudo crear el cliente.';
            this.no_internet &&
              (message += ' No cuenta con una conexión estable a internet.');
            this.toastSrv.error(message);
          },
        })
      );
    } else {
      this.formClient.markAllAsTouched();
    }
  }
}
